export default __webpack_public_path__ + "static/media/material_ui.058fe09b.png";